import SEO from '../components/SEO';
import GridBackground from '../components/GridBackground';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import WhatsAppFloatButton from '../components/WhatsAppFloatButton';
import ServicesHero from '../components/services/ServicesHero';
import ServiceList from '../components/services/ServiceList';
import ServicesCTA from '../components/services/ServicesCTA';
import { services } from '../components/services/servicesData';
import { breadcrumbLd } from '@/lib/structuredData';

export default function Services() {
  const urlParams = new URLSearchParams(window.location.search);
  const autoOpenProject = urlParams.get('open') === 'project';

  return (
    <div className="min-h-screen bg-background text-foreground relative">
      <SEO
        fullTitle="AI, Software, App & Cybersecurity Services in Dubai"
        description="Custom AI, websites, SaaS, mobile apps, automation, digital marketing and AI cybersecurity for businesses in Dubai and the UAE. Talk to Jotunheims."
        path="/services"
        structuredData={{
          '@context': 'https://schema.org',
          '@graph': [
            breadcrumbLd([{ label: 'Home', to: '/' }, { label: 'Services', to: '/services' }]),
            {
              '@type': 'ItemList',
              name: 'Digital Services for Businesses in Dubai & the UAE',
              itemListElement: services.map((s, i) => ({ '@type': 'ListItem', position: i + 1, name: s.title, url: `https://jotunheims.com/services/${s.slug}` }))
            }
          ]
        }}
      />
      <GridBackground />
      <Navbar />
      <ServicesHero autoOpenProject={autoOpenProject} />
      <ServiceList />
      <ServicesCTA />
      <Footer />
      <WhatsAppFloatButton />
    </div>
  );
}